import { type PipelineStage } from '../hooks/useProspects';

export const PIPELINE_STAGES: { value: PipelineStage; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'interested', label: 'Interested' },
  { value: 'committed', label: 'Committed' },
  { value: 'participant', label: 'Participant' },
  { value: 'closed_lost', label: 'Closed Lost' },
];

export const PARTICIPANT_GOAL = 100;

export const PIPELINE_COLORS: Record<PipelineStage, string> = {
  'new': 'bg-slate-200',
  'contacted': 'bg-slate-300',
  'qualified': 'bg-slate-400',
  'interested': 'bg-slate-500',
  'committed': 'bg-slate-600',
  'participant': 'bg-slate-800',
  'closed_lost': 'bg-red-300',
};